import * as stylex from '@stylexjs/stylex';
import { colors } from '@seeqdev/qomponents/colors.stylex';
import type { ICellRendererParams } from '@seeqdev/ag/grid';

export interface UserNameCellProps {
  first: string;
  last: string;
}

/**
 * This cell-renderer renders a circle with the first letter of the first and last name of the user as well as the
 * user's name
 */
export const UserNameCellRenderer = (props: ICellRendererParams<any, UserNameCellProps>) => {
  if (!props?.value) return null;
  const { first, last } = props.value;
  return (
    <div {...stylex.props(styles.root)}>
      <div {...stylex.props(styles.initials)}>
        {first?.substring(0, 1)}
        {last?.substring(0, 1)}
      </div>
      {first && first} {last && last}
    </div>
  );
};

const styles = stylex.create({
  root: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  initials: {
    marginRight: 5,
    display: 'flex',
    height: 30,
    minHeight: 30,
    width: 30,
    minWidth: 30,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: colors.accentPressed,
    color: colors.white,
    fontSize: 'small',
    textAlign: 'center',
  },
});
